// File type constants for claims ingestion
export const FILE_TYPES = {
  SINGLE_CLIENT_SINGLE_INSURER: 'single-client-single-insurer',
  SINGLE_CLIENT_MULTI_INSURER: 'single-client-multi-insurer',
  MULTI_CLIENT_SINGLE_INSURER: 'multi-client-single-insurer',
  MULTI_CLIENT_MULTI_INSURER: 'multi-client-multi-insurer',
} as const;

// File type display names for UI
export const FILE_TYPE_DISPLAY_NAMES = {
  SINGLE_CLIENT_SINGLE_INSURER: 'Single Client, Single Insurer',
  SINGLE_CLIENT_MULTI_INSURER: 'Single Client, Multi Insurer',
  MULTI_CLIENT_SINGLE_INSURER: 'Multi-Client, Single Insurer',
  MULTI_CLIENT_MULTI_INSURER: 'Multi-Client, Multi Insurer',
} as const;

// Derive the FileType type from the constants
export type FileType = (typeof FILE_TYPES)[keyof typeof FILE_TYPES];
